import { render, staticRenderFns } from "./UserEngagementTable.vue?vue&type=template&id=11a2ef84&"
import script from "./UserEngagementTable.vue?vue&type=script&lang=js&"
export * from "./UserEngagementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports